import React from 'react';

import { DataTableFilterMetaData } from 'primereact/datatable';

export const clearFilter = (
  filter: string,
  filters: Record<string, DataTableFilterMetaData>,
  setFilters: React.Dispatch<
    React.SetStateAction<Record<string, DataTableFilterMetaData>>
  >,
  ref?: React.RefObject<HTMLInputElement>,
  setPageNumber?: (pageNumber: number) => void,
  setFirst?: (first: number) => void
) => {
  const _filters = { ...filters };
  _filters[filter].value = null;
  setFilters(_filters);

  if (ref && ref.current) {
    ref.current.value = '';
  }

  if (setPageNumber) {
    setPageNumber(1);
  }

  if (setFirst) {
    setFirst(0);
  }
};
